<form>
  <div>

    <div class="flexie-auto-grid">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">Role</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-radio-group nzName="radiogroup" [(ngModel)]="clientRole" name="radiogroup">
            <label *ngFor="let role of RolesLookup" nz-radio nzValue="{{role.key}}">{{role.value}}</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="clientRole != null">
        <nz-form-label *ngIf="clientRole === 'OWNER'" [nzSpan]="24">Owner Type</nz-form-label>
        <nz-form-label *ngIf="clientRole === 'PAYER'" [nzSpan]="24">Payer Type</nz-form-label>
        <nz-form-label *ngIf="clientRole != 'OWNER' && clientRole != 'PAYER' " [nzSpan]="24">Type</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-radio-group nzName="radiogroup" [(ngModel)]="clientType" name="radiogroup">
            <label nz-radio nzValue="INDIVIDUAL">Person</label>
            <label nz-radio nzValue="ORGANIZATION">Organization</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

    </div>

    <nz-card style="width:100%" nzType="inner" style="margin-top:16px;" nzTitle="Individual Basic Details" [nzExtra]="extraTemplate">
      <div class="flexie-auto-grid">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">First Name</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="First Name" [(ngModel)]="firstName" name="input-basic" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Last Name</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Last Name" [(ngModel)]="LastName" name="input-basic" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Gender</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-radio-group nzName="radiogroup" [(ngModel)]="gender" name="radiogroup">
              <label nz-radio nzValue="MALE">Male</label>
              <label nz-radio nzValue="FEMALE">Female</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="flexie-auto-grid">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Date of Birth</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-date-picker placeholder="DD-MM-YYYY" [nzDisabledDate]="disabledDate" (ngModelChange)="onChange($event)" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Country of Birth {{cob}}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input [(ngModel)]="cob" placeholder="For Eg: {{appCountrySettings.currentCountryCd}}" nz-input (input)="onInput($event.target?.value)"
              [nzAutocomplete]="auto">
            <nz-autocomplete [nzDataSource]="filteredOptions" #auto>
            </nz-autocomplete>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Country of Citizenship {{coc}}</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <input [(ngModel)]="coc" placeholder="For Eg: {{appCountrySettings.currentCountryCd}}" nz-input (input)="onInput($event.target?.value)"
              [nzAutocomplete]="auto">
            <!-- <nz-autocomplete [nzDataSource]="filteredOptions" #auto>
            </nz-autocomplete> -->

            <nz-autocomplete nzBackfill #auto>
              <nz-auto-option *ngFor="let option of filteredOptions" [nzValue]="option">
                {{option}}
              </nz-auto-option>
            </nz-autocomplete>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div *ngIf="clientRole === 'PAYER' || clientRole === 'OWNERPAYER' " class="flexie-auto-grid">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Source of Income</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
              <nz-option nzValue="1" nzLabel="Salary"></nz-option>
              <nz-option nzValue="0" nzLabel="Savings"></nz-option>
              <nz-option nzValue="0" nzLabel="Investments"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
        <div></div>
        <div></div>
      </div>
    </nz-card>
    <ng-template #extraTemplate>
      <a>Reset</a>
    </ng-template>


    <nz-card style="width:100%" nzType="inner" style="margin-top:16px;" nzTitle="Contact Details" [nzExtra]="extraTemplate">

      <app-contactnumber-capture> </app-contactnumber-capture>
      <app-address-capture-indonesia></app-address-capture-indonesia>

    </nz-card>
    <ng-template #extraTemplate>
      <a>Reset</a>
    </ng-template>

    <nz-card *ngIf="clientRole === 'PAYER' || clientRole === 'OWNERPAYER' " style="width:100%" nzType="inner" style="margin-top:16px;"
      nzTitle="Additional Details" [nzExtra]="extraTemplate">

      <app-identity-capture></app-identity-capture>
      <app-occupation-capture></app-occupation-capture>


    </nz-card>
    <ng-template #extraTemplate>
      <a>Reset</a>
    </ng-template>



    <nz-card *ngIf="clientRole != null" style="width:100%" nzType="inner" style="margin-top:16px;" nzTitle="Roles" [nzExtra]="extraTemplate">

      <p *ngIf="clientRole === 'OWNER'" style="margin-bottom: 20px;">
        <label nz-checkbox [(ngModel)]="OwnerAsPayer" [nzDisabled]="isDisabledButton">
          Add Owner as Payer
        </label>
      </p>


      <p style="margin-bottom: 20px;">
          <label nz-checkbox [(ngModel)]="clientAsInsured" [nzDisabled]="isDisabledButton">
            Add {{ getRoleDescription(clientRole)}} as Insured
          </label>
        </p>


    </nz-card>



  </div>
</form>
